module.exports = __webpack_public_path__ + "static/img/アセット 21@2x.04505ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/アセット 21@2x.png
// module id = xy4r
// module chunks = 1